import React, { useState } from 'react';
import { toast } from 'sonner';
import { Layers } from 'lucide-react';
import api from '../../utils/axios';
import { useMotivoCambio } from './MotivoCambioDialog';

const CAMPOS = [
  { key: 'minimo_ocurrencias', label: 'Mín. movimientos nuevos', title: 'Movimientos nunca contados que hacen falta para abrir un episodio' },
  { key: 'ventana_deteccion_dias', label: 'Ventana (días)', title: 'Esos movimientos tienen que ser de los últimos N días' },
  { key: 'dias_vencimiento', label: 'Vence a los (días)', title: 'Días sin movimientos nuevos para que el episodio pase a VENCIDO' },
];

export const EpisodioConfig = ({ monitor, onSaved }) => {
  const [valores, setValores] = useState(() => Object.fromEntries(CAMPOS.map((c) => [c.key, monitor[c.key] ?? ''])));
  const [pedirMotivo, dialogoMotivo] = useMotivoCambio();
  const restaurar = (key) => setValores((v) => ({ ...v, [key]: monitor[key] ?? '' }));

  const guardar = async (c) => {
    const val = parseInt(valores[c.key], 10);
    if (!val || val < 1 || val === monitor[c.key]) {
      restaurar(c.key);
      return;
    }
    // Parte H: el motivo es obligatorio al cambiar un umbral.
    const motivo = await pedirMotivo(`«${monitor.nombre}» · ${c.label}: ${monitor[c.key] ?? '—'} → ${val}`);
    if (!motivo) {
      restaurar(c.key);
      return;
    }
    try {
      await api.patch(`/monitors/${monitor.id}`, { [c.key]: val, motivo_revision: motivo });
      toast.success('Configuración de episodios guardada');
      onSaved?.();
    } catch (e) {
      restaurar(c.key);
      toast.error(e.response?.data?.detail || 'No se pudo guardar la configuración de episodios');
    }
  };

  return (
    <div className="text-xs p-3 rounded mb-2 border bg-slate-50 border-slate-200" data-testid={`episodio-config-${monitor.id}`}>
      <p className="font-semibold text-slate-600 mb-2 flex items-center gap-1"><Layers size={11} /> Episodios</p>
      <div className="grid grid-cols-3 gap-2">
        {CAMPOS.map((c) => (
          <div key={c.key} title={c.title}>
            <label className="text-[10px] text-slate-500 leading-tight block">{c.label}</label>
            <input
              type="number"
              min="1"
              value={valores[c.key]}
              onChange={(e) => setValores((v) => ({ ...v, [c.key]: e.target.value }))}
              onBlur={() => guardar(c)}
              onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
              data-testid={`episodio-${c.key}-${monitor.id}`}
              className="w-full border border-slate-200 rounded px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-400"
            />
          </div>
        ))}
      </div>
      {dialogoMotivo}
    </div>
  );
};
